// src/components/link-group-tabs/link-group-tabs.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ImageFragment on Image {\n    aspectRatio\n    description\n    url\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageLinkFragment on EGDSImageLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n      useRelativePath\n    }\n    image {\n      ...ImageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageItemFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...CrossLinkImageLinkFragment\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageItemFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...CrossLinkImageLinkFragment\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageItemFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...CrossLinkImageLinkFragment\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageItemFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...CrossLinkImageLinkFragment\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageLinkCardFragment on CrossLinkImageLinkCard {\n    gaiaId\n    imagelink {\n      ...CrossLinkImageItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    description\n    size\n    theme\n    title\n    id\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkStandardLinkFragment on EGDSStandardLink {\n    action {\n      resource {\n        value\n      }\n      target\n      analytics {\n        linkName\n        referrerId\n      }\n      accessibility\n    }\n    icon {\n      ...IconFragment\n    }\n    iconPosition\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkStandardItemFragment on CrossLinkStandardLink {\n    description\n    link {\n      ...CrossLinkStandardLinkFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkItemFragment on CrossLinkItem {\n    ...CrossLinkStandardItemFragment\n    ...CrossLinkImageLinkCardFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkItemsHandlerFragment on CrossLinkList {\n    items {\n      ...CrossLinkItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkItemsHandlerFragment on CrossLinkList {\n    items {\n      ...CrossLinkItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkItemsHandlerFragment on CrossLinkList {\n    items {\n      ...CrossLinkItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinksGroupItemsFragment on CrossLinksGroupItems {\n    name\n    items {\n      ... on CrossLinkStandardLink {\n        ...CrossLinkStandardItemFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkOutlineFragment on CrossLinkOutline {\n    header\n    subheader\n    description\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  query LinkGroupTabsQuery(\n    $strategyName: String!\n    $context: ContextInput!\n    $uriContext: UriContextInput!\n    $parameters: [CrossLinksParameterInput!]\n    $limit: Int!\n  ) {\n    crosslinksGroups(context: $context, limit: $limit, strategyName: $strategyName, uriContext: $uriContext, parameters: $parameters) {\n      outline {\n        ...CrossLinkOutlineFragment\n      }\n      items {\n        ...CrossLinksGroupItemsFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
import React18 from "react";
import { gql as gql17, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker, useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/crosslink-items/crosslink-group-items.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
// ../internal/src/components/crosslink-items/crosslink-items-handler.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/crosslink-items/micro-components/select-display.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/crosslink-items/crosslink-item.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
// ../internal/src/components/crosslink-items/micro-components/types.ts
var columnsMap = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    8: 8,
    12: 12
};
// ../internal/src/components/crosslink-items/crosslink-image-link-card.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/crosslink-items/crosslink-image-item.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker as useClickTracker2, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
// ../internal/src/components/crosslink-items/micro-components/clickstream-constants.ts
var DESTINATIONS_CAROUSEL_CARD_SELECTED_EVENT_CONSTANTS = {
    EVENT_NAME: "destinations_carousel_card.selected",
    EVENT_TYPE: "Interaction" /* INTERACTION */ ,
    EVENT_VERSION: "1.2.0"
};
// ../internal/src/components/crosslink-items/micro-components/clickstream-utils.ts
var clickstreamEventBuilder = function(clickStreamEventConstants) {
    return {
        event: {
            event_type: clickStreamEventConstants.EVENT_TYPE,
            event_name: clickStreamEventConstants.EVENT_NAME,
            event_version: clickStreamEventConstants.EVENT_VERSION
        }
    };
};
// ../internal/src/components/crosslink-items/micro-components/select-view.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/crosslink-items/crosslink-image-link.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
// ../internal/src/components/image/image.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "uitk-react-images";
// ../internal/src/components/image/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj;
var aspectRatioMapper = (_obj = {}, _define_property(_obj, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _define_property(_obj, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _define_property(_obj, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _define_property(_obj, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _define_property(_obj, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _define_property(_obj, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _define_property(_obj, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj);
// ../internal/src/components/image/image.tsx
var fragment = gql(_templateObject());
var Image = function(props) {
    var _props_data = props.data, aspectRatio = _props_data.aspectRatio, description = _props_data.description, url = _props_data.url;
    return /* @__PURE__ */ React.createElement(UitkFigure, {
        ratio: aspectRatio ? aspectRatioMapper[aspectRatio] : UitkFigureAspectRatioType2.R16_9
    }, /* @__PURE__ */ React.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: url,
        lazyLoading: "lazy"
    }));
};
Image.fragment = fragment;
Image.displayName = "Image";
// ../internal/src/components/crosslink-items/crosslink-image-link.tsx
var fragment2 = gql2(_templateObject1(), Image.fragment);
var CrossLinkImageLink = function(props) {
    var data = props.data, _props_isLinkInsideOfTheCard = props.isLinkInsideOfTheCard, isLinkInsideOfTheCard = _props_isLinkInsideOfTheCard === void 0 ? true : _props_isLinkInsideOfTheCard;
    var image = data.image, action = data.action;
    var analytics = action.analytics, resource = action.resource, target = action.target;
    var clickTracker = useClickTracker();
    var onClickCapture = React2.useCallback(function() {
        return clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        analytics.linkName,
        analytics.referrerId,
        clickTracker
    ]);
    if (data.__typename === "EGDSImageLink") {
        if (isLinkInsideOfTheCard) {
            return /* @__PURE__ */ React2.createElement(Image, {
                data: image
            });
        }
        return /* @__PURE__ */ React2.createElement(UitkLink, {
            onClickCapture: onClickCapture
        }, /* @__PURE__ */ React2.createElement("a", {
            href: resource.value,
            target: target
        }, /* @__PURE__ */ React2.createElement(Image, {
            data: image
        })));
    }
    return null;
};
CrossLinkImageLink.fragment = fragment2;
CrossLinkImageLink.displayName = "CrossLinkImageLink";
// ../internal/src/components/crosslink-items/micro-components/crosslink-featured-locations-image-item.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkBadgeStandard } from "uitk-react-badge";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
var fragment3 = gql3(_templateObject2(), CrossLinkImageLink.fragment);
var overlayLayout = {
    top: "zero",
    right: "zero",
    bottom: "zero",
    left: "zero"
};
var FeaturedLocationsComponent = function(props) {
    var data = props.data, headingTag = props.headingTag;
    var link = data.link, description = data.description, title = data.title, subTitle = data.subTitle;
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React3.createElement(CrossLinkImageLink, {
        data: link
    }), /* @__PURE__ */ React3.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: overlayLayout,
        cloneElement: true,
        "aria-hidden": true
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        alignItems: "center",
        justifyContent: "center"
    }, description && /* @__PURE__ */ React3.createElement(UitkBadgeStandard, {
        text: description
    })))), /* @__PURE__ */ React3.createElement(UitkCardContentSection, null, title && /* @__PURE__ */ React3.createElement(UitkHeading, {
        tag: headingTag,
        overflow: "truncate"
    }, title), subTitle && /* @__PURE__ */ React3.createElement(UitkSubheading, null, " ", subTitle, " ")));
};
FeaturedLocationsComponent.fragment = fragment3;
FeaturedLocationsComponent.displayName = "FeaturedLocationsComponent";
// ../internal/src/components/crosslink-items/micro-components/crosslink-regular-image-item.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkHeading as UitkHeading2, UitkSubheading as UitkSubheading2 } from "uitk-react-text";
var fragment4 = gql4(_templateObject3(), CrossLinkImageLink.fragment);
var RegularComponent = function(props) {
    var data = props.data, headingTag = props.headingTag;
    var link = data.link, title = data.title, description = data.description;
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(UitkLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React4.createElement(CrossLinkImageLink, {
        data: link
    })), /* @__PURE__ */ React4.createElement(UitkCardContentSection2, null, title && /* @__PURE__ */ React4.createElement(UitkHeading2, {
        tag: headingTag,
        overflow: "truncate"
    }, title), description && /* @__PURE__ */ React4.createElement(UitkSubheading2, null, description)));
};
RegularComponent.fragment = fragment4;
RegularComponent.displayName = "RegularComponent";
// ../internal/src/components/crosslink-items/micro-components/select-view.tsx
var fragment5 = gql5(_templateObject4(), CrossLinkImageLink.fragment);
var SelectView = function(props) {
    var view = props.view, headingTag = props.headingTag, data = props.data;
    var displayByView = {
        regular: function Regular() {
            return /* @__PURE__ */ React5.createElement(RegularComponent, {
                headingTag: headingTag,
                data: data
            });
        },
        featured: function FeaturedLocations() {
            return /* @__PURE__ */ React5.createElement(FeaturedLocationsComponent, {
                headingTag: headingTag,
                data: data
            });
        }
    };
    return displayByView[view]();
};
SelectView.fragment = fragment5;
SelectView.displayName = "SelectView";
// ../internal/src/components/crosslink-items/crosslink-image-item.tsx
var fragment6 = gql6(_templateObject5(), CrossLinkImageLink.fragment);
var CrossLinkImageItem = function(props) {
    var data = props.data, padded = props.padded, border = props.border, selected = props.selected, _props_headingTag = props.headingTag, headingTag = _props_headingTag === void 0 ? "h6" : _props_headingTag, onSelect = props.onSelect, onDeselect = props.onDeselect, _props_view = props.view, view = _props_view === void 0 ? "regular" : _props_view;
    var link = data.link;
    var action = link.action;
    var clickTracker = useClickTracker2();
    var track = useEgClickstream();
    var onClickCapture = React6.useCallback(function() {
        var publishClickstreamEvent = function(clickstreamEventConstants) {
            var clickstreamEvent = clickstreamEventBuilder(clickstreamEventConstants);
            track(clickstreamEvent);
        };
        clickTracker(action.analytics.referrerId, action.analytics.linkName);
        publishClickstreamEvent(DESTINATIONS_CAROUSEL_CARD_SELECTED_EVENT_CONSTANTS);
    }, [
        action.analytics.linkName,
        action.analytics.referrerId,
        clickTracker,
        track
    ]);
    return /* @__PURE__ */ React6.createElement(UitkCard, {
        padded: padded,
        border: border,
        selected: selected
    }, /* @__PURE__ */ React6.createElement(UitkCardLink, null, /* @__PURE__ */ React6.createElement("a", {
        href: action.resource.value,
        onClickCapture: onClickCapture,
        onMouseEnter: onSelect,
        onMouseLeave: onDeselect
    }, action.accessibility)), /* @__PURE__ */ React6.createElement(SelectView, {
        data: data,
        view: view,
        headingTag: headingTag
    }));
};
CrossLinkImageItem.fragment = fragment6;
CrossLinkImageItem.displayName = "CrossLinkImageItem";
// ../internal/src/components/crosslink-items/crosslink-image-link-card.tsx
var fragment7 = gql7(_templateObject6(), CrossLinkImageItem.fragment);
var CrossLinkImageLinkCard = function(props) {
    var data = props.data, onSelect = props.onSelect, onDeselect = props.onDeselect, selected = props.selected, view = props.view;
    var gaiaId = data.gaiaId, imagelink = data.imagelink;
    return /* @__PURE__ */ React7.createElement("div", {
        "data-gaiaid": gaiaId
    }, /* @__PURE__ */ React7.createElement(CrossLinkImageItem, {
        border: true,
        data: imagelink,
        selected: selected,
        "data-gaiaid": gaiaId,
        view: view,
        onDeselect: onDeselect,
        onSelect: onSelect
    }));
};
CrossLinkImageLinkCard.fragment = fragment7;
CrossLinkImageLinkCard.displayName = "CrossLinksImageLinkCard";
// ../internal/src/components/crosslink-items/crosslink-standard-item.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
// ../internal/src/components/crosslink-items/crosslink-standard-link.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/icon/icon.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment8 = gql8(_templateObject7());
var _obj1;
var mapper = (_obj1 = {}, _define_property(_obj1, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize.EXTRA_SMALL), _define_property(_obj1, "SMALL" /* SMALL */ , UitkIconSize.SMALL), _define_property(_obj1, "MEDIUM" /* MEDIUM */ , UitkIconSize.MEDIUM), _define_property(_obj1, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize.MEDIUM), _define_property(_obj1, "LARGE" /* LARGE */ , UitkIconSize.LARGE), _define_property(_obj1, "XLARGE" /* XLARGE */ , UitkIconSize.XLARGE), _obj1);
var Icon = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React8.createElement(UitkIcon, {
        id: data.id,
        name: data.id,
        size: data.size ? mapper[data.size] : void 0,
        title: data.title || void 0,
        description: data.description
    });
};
Icon.fragment = fragment8;
Icon.displayName = "Icon";
// ../internal/src/components/crosslink-items/crosslink-standard-link.tsx
var fragment9 = gql9(_templateObject8(), Icon.fragment);
var CrossLinkStandardLink = function(props) {
    var data = props.data, target = props.target;
    var action = data.action, icon = data.icon, text = data.text, iconPosition = data.iconPosition;
    var analytics = action.analytics, resource = action.resource;
    var clickTracker = useClickTracker3();
    var onClickCapture = React9.useCallback(function() {
        return clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        analytics.linkName,
        analytics.referrerId,
        clickTracker
    ]);
    return /* @__PURE__ */ React9.createElement(UitkText, {
        wordBreak: true
    }, /* @__PURE__ */ React9.createElement(UitkLink2, {
        onClickCapture: onClickCapture
    }, /* @__PURE__ */ React9.createElement("a", {
        href: resource.value,
        target: target
    }, icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React9.createElement(Icon, {
        data: icon
    }), text, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React9.createElement(Icon, {
        data: icon
    }), action.accessibility && /* @__PURE__ */ React9.createElement(UitkText, {
        className: "is-visually-hidden"
    }, action.accessibility))));
};
CrossLinkStandardLink.fragment = fragment9;
CrossLinkStandardLink.displayName = "CrossLinkStandardLink";
// ../internal/src/components/crosslink-items/crosslink-standard-item.tsx
var fragment10 = gql10(_templateObject9(), CrossLinkStandardLink.fragment);
var CrossLinkStandardItem = function(props) {
    var data = props.data, target = props.target;
    var description = data.description, link = data.link;
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(CrossLinkStandardLink, {
        target: target,
        data: link
    }), description && /* @__PURE__ */ React10.createElement(UitkParagraph, {
        size: 3
    }, description));
};
CrossLinkStandardItem.fragment = fragment10;
CrossLinkStandardItem.displayName = "CrossLinkStandardItem";
// ../internal/src/components/crosslink-items/crosslink-item.tsx
var fragment11 = gql11(_templateObject10(), CrossLinkStandardItem.fragment, CrossLinkImageLinkCard.fragment);
var CrossLinkItem = function(props) {
    var data = props.data, onSelect = props.onSelect, onDeselect = props.onDeselect, selected = props.selected, _props_target = props.target, target = _props_target === void 0 ? "_blank" /* BLANK */  : _props_target, view = props.view;
    if (data.__typename === "CrossLinkStandardLink") {
        return /* @__PURE__ */ React11.createElement(CrossLinkStandardItem, {
            target: target,
            data: data
        });
    }
    if (data.__typename === "CrossLinkImageLinkCard") {
        return /* @__PURE__ */ React11.createElement(CrossLinkImageLinkCard, {
            data: data,
            view: view,
            selected: selected,
            onDeselect: onDeselect,
            onSelect: onSelect
        });
    }
    return null;
};
CrossLinkItem.fragment = fragment11;
CrossLinkItem.displayName = "CrossLinkItem";
// ../internal/src/components/crosslink-items/micro-components/crosslink-grid-item-handler.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkView } from "uitk-react-view";
var fragment12 = gql12(_templateObject11(), CrossLinkItem.fragment);
var getGridColumns = function(columns, viewport) {
    var _filteredViewportSize;
    if (typeof columns === "number" || typeof columns === "string") {
        return parseInt(columns.toString(), 10);
    }
    var filteredViewportSize = Object.keys(defaultViewSizes).find(function(key) {
        return defaultViewSizes[key] === viewport;
    });
    if (filteredViewportSize && columns[(_filteredViewportSize = filteredViewportSize) === null || _filteredViewportSize === void 0 ? void 0 : _filteredViewportSize.toLowerCase()]) {
        return columns[filteredViewportSize.toLowerCase()];
    }
    var filteredSmallerViewportSizes = Object.keys(defaultViewSizes).filter(function(key) {
        return defaultViewSizes[key] <= viewport;
    });
    var filteredSmallerViewports = [];
    filteredSmallerViewportSizes.forEach(function(size) {
        if (columns[size.toLowerCase()]) {
            filteredSmallerViewports.push(columns[size.toLowerCase()]);
        }
    });
    if (filteredSmallerViewports.length) {
        var _Math;
        return (_Math = Math).max.apply(_Math, _to_consumable_array(filteredSmallerViewports));
    }
    return 4;
};
var Grid = function(props) {
    var viewport = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var data = props.data, _props_columns = props.columns, columns = _props_columns === void 0 ? 4 : _props_columns, _props_target = props.target, target = _props_target === void 0 ? "_blank" /* BLANK */  : _props_target, _props_isWithSpacing = props.isWithSpacing, isWithSpacing = _props_isWithSpacing === void 0 ? true : _props_isWithSpacing, _props_isWithCard = props.isWithCard, isWithCard = _props_isWithCard === void 0 ? true : _props_isWithCard;
    var items = data.items;
    var gridColumns = getGridColumns(columns, viewport);
    var content = /* @__PURE__ */ React12.createElement(UitkSpacing, {
        padding: isWithSpacing ? "three" : "unset"
    }, /* @__PURE__ */ React12.createElement(UitkLayoutGrid, {
        columns: typeof columns === "number" || typeof columns === "string" ? columnsMap[columns] : columns,
        space: {
            column: "six"
        },
        "data-stid": "layoutgrid"
    }, _to_consumable_array(Array(gridColumns)).map(function(v, k) {
        return /* @__PURE__ */ React12.createElement(UitkLayoutGridItem, {
            key: "grid-item-".concat(k)
        }, /* @__PURE__ */ React12.createElement(UitkView, null, items.map(function(item, index) {
            return (index % gridColumns === k || index === k) && /* @__PURE__ */ React12.createElement(CrossLinkItem, {
                data: item,
                target: target,
                key: "links-".concat(index)
            });
        })));
    })));
    if (!isWithCard) {
        return content;
    }
    return /* @__PURE__ */ React12.createElement(UitkCard2, null, /* @__PURE__ */ React12.createElement(React12.Fragment, null, content));
};
Grid.fragment = fragment12;
Grid.displayName = "Grid";
// ../internal/src/components/crosslink-items/micro-components/select-display.tsx
var fragment13 = gql13(_templateObject12(), CrossLinkItem.fragment);
var SelectDisplay = function(props) {
    var strategy = props.strategy, data = props.data, columns = props.columns, target = props.target;
    var displayByStrategy = {
        "plan-your-trip": function pytDisplay() {
            return /* @__PURE__ */ React13.createElement(Grid, {
                data: data,
                columns: columns,
                target: target
            });
        },
        "destination-cross-link": function dclDisplay() {
            return /* @__PURE__ */ React13.createElement(Grid, {
                data: data,
                columns: columns,
                target: target
            });
        },
        "link-juice": function ljDisplay() {
            return /* @__PURE__ */ React13.createElement(Grid, {
                data: data,
                target: target,
                columns: columns,
                isWithSpacing: false
            });
        },
        "affinity-linkpiles": function alpDisplay() {
            return /* @__PURE__ */ React13.createElement(Grid, {
                data: data,
                target: target,
                columns: columns
            });
        },
        custom: function cstmDisplay() {
            return /* @__PURE__ */ React13.createElement(Grid, {
                data: data,
                target: target,
                columns: columns,
                isWithCard: false,
                isWithSpacing: false
            });
        },
        geolinkpiles: function glpDisplay() {
            return /* @__PURE__ */ React13.createElement(Grid, {
                data: data,
                target: target,
                columns: columns,
                isWithCard: false
            });
        },
        "geo-affinity-linkpiles": function alpDisplay() {
            return /* @__PURE__ */ React13.createElement(Grid, {
                data: data,
                target: target,
                columns: columns
            });
        }
    };
    return displayByStrategy[strategy]();
};
SelectDisplay.fragment = fragment13;
SelectDisplay.displayName = "SelectDisplay";
// ../internal/src/components/crosslink-items/crosslink-items-handler.tsx
var fragment14 = gql14(_templateObject13(), CrossLinkItem.fragment);
var TYPENAMES_ALLOWED = [
    "CrossLinkList",
    "CrossLinksGroupItems"
];
var CrossLinkItemsHandler = function(props) {
    var _data;
    var data = props.data, strategy = props.strategy, columns = props.columns, target = props.target;
    if (!TYPENAMES_ALLOWED.includes((_data = data) === null || _data === void 0 ? void 0 : _data.__typename)) {
        return null;
    }
    return /* @__PURE__ */ React14.createElement(SelectDisplay, {
        data: data,
        strategy: strategy,
        columns: columns,
        target: target
    });
};
CrossLinkItemsHandler.fragment = fragment14;
CrossLinkItemsHandler.displayName = "CrossLinkItemsHandler";
// ../internal/src/components/crosslink-items/crosslink-group-items.tsx
var fragment15 = gql15(_templateObject14(), CrossLinkStandardItem.fragment);
var CrossLinksGroupItems = function(props) {
    var data = props.data, target = props.target, strategyName = props.strategyName, _props_columns = props.columns, columns = _props_columns === void 0 ? 4 : _props_columns;
    return /* @__PURE__ */ React15.createElement(CrossLinkItemsHandler, {
        data: data,
        target: target,
        columns: columns,
        strategy: strategyName
    });
};
CrossLinksGroupItems.fragment = fragment15;
CrossLinksGroupItems.displayName = "CrossLinkGroupHandler";
// ../internal/src/components/crosslink-outline/crosslink-outline.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkCard as UitkCard3 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkParagraph as UitkParagraph2, UitkSubheading as UitkSubheading3 } from "uitk-react-text";
var fragment16 = gql16(_templateObject15());
var headerSizeMap = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8
};
var headerTagMap = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6"
};
var CrossLinkOutline = function(props) {
    var data = props.data, headerSize = props.headerSize, headerTag = props.headerTag, secondaryBackgroundColor = props.secondaryBackgroundColor, _props_isWithCard = props.isWithCard, isWithCard = _props_isWithCard === void 0 ? true : _props_isWithCard;
    var header = data.header, subheader = data.subheader, description = data.description;
    if (header === "" && subheader === "" && description === "") {
        return null;
    }
    var content = /* @__PURE__ */ React16.createElement(UitkSpacing2, {
        margin: isWithCard ? "unset" : {
            blockend: "four"
        }
    }, /* @__PURE__ */ React16.createElement("div", null, header && /* @__PURE__ */ React16.createElement(UitkHeading3, {
        size: headerSizeMap[headerSize !== null && headerSize !== void 0 ? headerSize : 6],
        tag: headerTagMap[headerTag !== null && headerTag !== void 0 ? headerTag : "h2"]
    }, header), subheader && /* @__PURE__ */ React16.createElement(UitkSubheading3, {
        tag: "p"
    }, subheader), description && /* @__PURE__ */ React16.createElement(UitkParagraph2, {
        size: 3
    }, description)));
    if (isWithCard) {
        return /* @__PURE__ */ React16.createElement(UitkCard3, {
            padded: true,
            backgroundTheme: secondaryBackgroundColor ? "secondary" : "primary"
        }, content);
    }
    return content;
};
CrossLinkOutline.fragment = fragment16;
CrossLinkOutline.displayName = "CrossLinkOutline";
// src/components/link-group-tabs/link-group-tabs.tsx
import { UitkCard as UitkCard5 } from "uitk-react-cards";
import { UitkTab, UitkTabs, UitkTabsBackGroundColorType, UitkTabsType } from "uitk-react-tabs";
// src/components/link-group-tabs/__private/__fragments/link-group-tabs-placeholder.tsx
import React17 from "react";
import { UitkCard as UitkCard4, UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLineSkeleton } from "uitk-react-skeleton";
var LinkGroupTabsPlaceholder = function() {
    return /* @__PURE__ */ React17.createElement(UitkCard4, {
        padded: true
    }, /* @__PURE__ */ React17.createElement(UitkLayoutGrid2, {
        columns: {
            large: 4,
            small: 1,
            medium: 1
        }
    }, new Array(4).fill(0).map(function(_, i) {
        return /* @__PURE__ */ React17.createElement(UitkLayoutGridItem2, {
            key: "skeleton-entry-".concat(i)
        }, /* @__PURE__ */ React17.createElement(UitkCard4, {
            padded: false
        }, /* @__PURE__ */ React17.createElement(UitkCardContentSection3, null, /* @__PURE__ */ React17.createElement(UitkLineSkeleton, null)), /* @__PURE__ */ React17.createElement(UitkCardContentSection3, null, /* @__PURE__ */ React17.createElement(UitkLineSkeleton, {
            animation: true,
            type: "secondary"
        }))));
    })));
};
// src/components/link-group-tabs/link-group-tabs.tsx
var EventTracking = /* @__PURE__ */ function(EventTracking2) {
    EventTracking2["geolinkpiles"] = "geolinkpiles";
    return EventTracking2;
}(EventTracking || {});
function buildEgClickstreamData(input) {
    var result = {
        event: {
            event_name: "",
            event_type: "",
            event_version: "",
            event_category: ""
        },
        experience: {
            app_name: "shared-ui",
            app_version: "1.0.0",
            page_name: ""
        }
    };
    if (input === "geolinkpiles" /* geolinkpiles */ ) {
        result.event.event_name = "geo_tabbed_link_piles.presented";
        result.event.event_type = "Impression";
        result.event.event_version = "1.0.0";
        result.experience.page_name = "Search Landing Page";
    }
    return result;
}
var TabGroupWrapper = function(props) {
    var _crosslinksGroups, _crosslinksGroups_items_filter, _crosslinksGroups_items, _crosslinksGroups1;
    var strategyName = props.strategyName, secondaryBackgroundColor = props.secondaryBackgroundColor, crosslinksGroups = props.crosslinksGroups;
    var _React18_useState = _sliced_to_array(React18.useState(0), 2), selectedTabIndex = _React18_useState[0], setSelectedTabIndex = _React18_useState[1];
    var clickTracker = useClickTracker4();
    var onSelectTab = React18.useCallback(function(tab) {
        setSelectedTabIndex(tab);
        if (strategyName === "geolinkpiles" /* geolinkpiles */ ) {
            var linkName = "RFRR Action Event";
            var referrerId = "tab-group-1.tab.".concat(tab, ".click");
            clickTracker(referrerId, linkName);
        }
    }, [
        strategyName,
        clickTracker
    ]);
    return /* @__PURE__ */ React18.createElement(UitkCard5, {
        backgroundTheme: secondaryBackgroundColor ? "secondary" : "primary",
        className: "TabGroup dynamicHeightTabGroup"
    }, ((_crosslinksGroups = crosslinksGroups) === null || _crosslinksGroups === void 0 ? void 0 : _crosslinksGroups.outline) && /* @__PURE__ */ React18.createElement(CrossLinkOutline, {
        data: crosslinksGroups.outline,
        headerSize: 4,
        secondaryBackgroundColor: secondaryBackgroundColor
    }), /* @__PURE__ */ React18.createElement(UitkTabs, {
        onTabSelect: onSelectTab,
        selectedTab: selectedTabIndex,
        tabsType: UitkTabsType.NATURAL,
        backgroundColor: secondaryBackgroundColor ? UitkTabsBackGroundColorType.SECONDARY : UitkTabsBackGroundColorType.PRIMARY,
        withBorder: false
    }, (_crosslinksGroups1 = crosslinksGroups) === null || _crosslinksGroups1 === void 0 ? void 0 : (_crosslinksGroups_items = _crosslinksGroups1.items) === null || _crosslinksGroups_items === void 0 ? void 0 : (_crosslinksGroups_items_filter = _crosslinksGroups_items.filter(function(tab) {
        return tab.name && tab.name !== "";
    })) === null || _crosslinksGroups_items_filter === void 0 ? void 0 : _crosslinksGroups_items_filter.map(function(tab, index) {
        return(// eslint-disable-next-line react/jsx-key
        /* @__PURE__ */ React18.createElement(UitkTab, {
            name: tab.name,
            id: "tab-".concat(index),
            tabLinkAttr: {
                id: "tab-".concat(index)
            },
            key: "tab-".concat(index),
            targetURI: "?equalTargetTab=tab-".concat(index)
        }, /* @__PURE__ */ React18.createElement(CrossLinksGroupItems, {
            data: tab,
            target: "_self" /* SELF */ ,
            strategyName: strategyName,
            columns: {
                large: 4,
                small: 1
            }
        })));
    })));
};
var __Query = gql17(_templateObject16(), CrossLinkOutline.fragment, CrossLinksGroupItems.fragment);
var LinkGroupTabs = function(props) {
    var _data_crosslinksGroups, _data, _data1, _data2, _data3;
    var inputs = props.inputs, skipSsr = props.skipSsr, secondaryBackgroundColor = props.secondaryBackgroundColor;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var isEnableEventTracking = inputs.strategyName in EventTracking;
    var eventTrigger = inputs.strategyName;
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        return /* @__PURE__ */ React18.createElement(LinkGroupTabsPlaceholder, null);
    }
    if (error || ((_data = data) === null || _data === void 0 ? void 0 : (_data_crosslinksGroups = _data.crosslinksGroups) === null || _data_crosslinksGroups === void 0 ? void 0 : _data_crosslinksGroups.__typename) !== "CrossLinksGroups" || !((_data1 = data) === null || _data1 === void 0 ? void 0 : _data1.crosslinksGroups.items) || ((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.crosslinksGroups.items) && !(((_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.crosslinksGroups.items.length) > 0)) {
        return null;
    }
    return isEnableEventTracking ? /* @__PURE__ */ React18.createElement(EgClickstreamImpressionTracker, {
        eventData: buildEgClickstreamData(eventTrigger)
    }, /* @__PURE__ */ React18.createElement(TabGroupWrapper, {
        strategyName: inputs.strategyName,
        secondaryBackgroundColor: secondaryBackgroundColor,
        crosslinksGroups: data.crosslinksGroups
    })) : /* @__PURE__ */ React18.createElement(TabGroupWrapper, {
        strategyName: inputs.strategyName,
        secondaryBackgroundColor: secondaryBackgroundColor,
        crosslinksGroups: data.crosslinksGroups
    });
};
LinkGroupTabs.displayName = "sharedui-LinkGroupTabs";
export { LinkGroupTabs };
//# sourceMappingURL=index.js.map